import React from 'react'

import { counterStyles } from './styles'
import { Sentiment } from '@sidecar-components/types'
import { CounterProps } from './Counter.types'

export const Counter = ({
  className = '',
  children,
  sentiment = Sentiment.RISK,
  testId,
}: CounterProps) => {
  return (
    <span
      className={`${counterStyles({ sentiment })} ${className}`}
      data-testid={testId}
    >
      {children}
    </span>
  )
}
